export default "__VITE_ASSET__BjKI84X2__"